/**
 * Quill（npm）を読み込み、従来スクリプト互換用に window に公開する
 */
import Quill from 'quill';

window.Quill = Quill;
